import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import {
  readRateLimitBlockFromSearchParams,
  saveRateLimitBlock,
} from '../../utils/rateLimitStorage';

/**
 * Legacy /auth/rate-limited route — persists block state and uses the global modal on /.
 */
export default function RateLimitedLegacyRedirect() {
  const [searchParams] = useSearchParams();
  const block = readRateLimitBlockFromSearchParams(searchParams);

  useEffect(() => {
    if (block) {
      saveRateLimitBlock(block);
    }
  }, [block]);

  return <Navigate to="/" replace />;
}
